import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import TicketingAdministrativeAreasService from 'js/services/api/ticketing/administrative-areas.js'
import PassengerPaymentMediasService from 'js/services/api/passenger/payment-medias.js'
import ApiClientsService from 'js/services/api/api-clients.js'
import {DEFAULT_MEDIA_TYPE, MEDIA_TYPE_OPTIONS} from 'js/pages/recharge/config.js'
import ProductsPrice from 'js/services/api/passenger/productsByCard.js'
import SupportTypes from 'js/services/api/passenger/supportType'

import template from 'js/pages/recharge/_basic-data.pug'

export default Vue.extend({
  name: 'top-up-basic-data',
  template: template(),
  props: {
    text: {
      type: String,
      default: undefined
    },
    formData: {
      type: Object,
      default() {
        return {
          administrative_area_id: undefined,
          administrative_area_code: undefined,
          media_code: undefined,
          media_type: '1'
        }
      }
    }
  },
  data() {
    return {
      products: [],
      supportTypes: [],
      web_title: Vue.store.state.webTitle,
      // Datos
      administrative_area_id: null,
      ready: false,
      media_code: undefined,
      media_type: undefined,
      // Indicia si la recarga será sobre un mediaType propio
      isNominalRecharge: true,
      // Sólo se llama si el usuario está logueado, nos trae los medios de pago que tiene el client
      clientMedias: {},
      nominalMediaSelected: {},
      // Elementos de ayuda del formulario
      selectorDisabled: false,
      administrativeAreas: [],
      // Errores en el formulario
      mediaCodeError: undefined,
      administrativeAreaCodeError: undefined,
      rechargeSupportImageLoadError: false,
      // Filtros
      onlyNumbers: (oldValue, value) => {
        if (value === '') return ''
        if (value && String(value).trim().match(/^[0-9]*$/)) {
          return String(value).trim()
        }
        if (oldValue) {
          return String(oldValue).trim()
        }
        return ''
      }
    }
  },
  computed: {
    ...mapGetters('administrativeArea', [
      'hasAdministrativeArea',
      'administrativeAreaId',
    ]),
    ...mapGetters('municipality', [
      'availableMunicipalities'
    ]),

    foreignRecharge() {
      // verifica si tiene media_type TSC monedero
      const media_type_1 = this.administrativeArea.media_types?.some(
        types => types.code.toString() === '1'
      )

      // verifica si tiene support_type TSC producto
      const support_type_1 = this.supportTypes?.some(types => types.code.toString() === '1')

      if (!media_type_1 && !support_type_1) {
        if (!this.administrativeArea?.enable_qr) {
          return false
        }
      }

      return true
    },

    isEnableAbt() {
      if (!this.administrativeArea.enable_qr &&
          this.clientMediasOfCurrentCity?.length > 0) {
        if (this.clientMediasOfCurrentCity?.some(media => media.mediaType !== '2')) {
          return true
        }

        return false
      }

      return true
    },

    mediaCodeMaxLength() {
      if (this.media_type === '1') {
        return 9
      }
      return 8
    },

    userHasMediaInCurrentCity() {
      // Si no tenemos usuario logueado devolvemos false
      if (!this.$user || _.isEmpty(this.administrative_area_id)) return false

      return !_.isEmpty(this.clientMedias) && !_.isEmpty(this.clientMediasOfCurrentCity)
    },

    userHasMediaInCurrentCityTranslate() {
      if (!this.isEnableAbt) {
        return 'anonymous'
      }
      return this.userHasMediaInCurrentCity ? 'user_has_media_in_current_city' : 'anonymous'
    },

    currentRechargeIsNominal() {
      return this.userHasMediaInCurrentCity && this.isNominalRecharge
    },

    clientMediasOfCurrentCity() {
      return this.clientMedias[this.administrative_area_id]
    },

    currentMediaSelected() {
      let media = {
        mediaCode: this.media_code,
        mediaType: this.media_type
      }

      if (this.currentRechargeIsNominal) media = this.nominalMediaSelected

      return media
    },

    administrativeAreaOptions() {
      return this.administrativeAreas.map(administrativeArea => ({
        value: administrativeArea.id,
        label: administrativeArea.consortium_name
      }))
    },

    administrativeAreaT() {
      return this.administrativeAreas.find(
        administrativeArea => this.administrative_area_id === administrativeArea.id
      )
    },

    administrativeAreaLoaded() {
      return this.hasAdministrativeArea && this.administrativeAreaId === this.administrative_area_id
    },

    mediaTypeOptions() {
      let types = MEDIA_TYPE_OPTIONS

      if (!this.administrativeArea.enable_abt_account) {
        types = types.filter(media => media.value !== '2')
      }

      return types
    },

    rechargeSupportImageUrl() {
      return (this.administrativeArea?.config?.recharge_support_image_url || '').trim()
    },

    rechargeSupportImageName() {
      return (this.administrativeArea?.config?.recharge_support_image_name || '').trim()
    },

    showRechargeSupportImage() {
      return !!this.rechargeSupportImageUrl && !this.rechargeSupportImageLoadError
    }
  },

  watch: {
    // Si cambia la URL (p.ej. config actualizada), reintentamos pintar la imagen
    rechargeSupportImageUrl(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.rechargeSupportImageLoadError = false
      }
    },

    administrative_area_id(newId, oldId) {
      const {administrativeAreaT} = this

      this.administrative_area_code = administrativeAreaT ? administrativeAreaT.code : null

      if (this.$user && this.clientMedias[newId]) {
        this.nominalMediaSelected = this.clientMedias[newId][0]
      }

      if (oldId) {
        // this.media_type = DEFAULT_MEDIA_TYPE
        this.media_code = undefined
        this.mediaCodeError = undefined
      }

      this.rechargeSupportImageLoadError = false
    },

    clientMediasOfCurrentCity(newMedias) {
      if (newMedias.length > 0 && !this.administrativeAreaLoaded) {
        this.loadAdministrativeArea({administrativeAreaId: this.administrative_area_id})
      }
    },

    isNominalRecharge(newVal) {
      if (newVal && _.isEmpty(this.nominalMediaSelected)) {
        this.nominalMediaSelected = this.clientMediasOfCurrentCity[0]
      }
    },

    $user(val) {
      if (val) {
        this.ready = false
        this.isNominalRecharge = true
        this.loadInitialData()
      }
    },

    media_type(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.media_code = undefined
        this.mediaCodeError = undefined
      }
    },

    administrativeAreaLoaded(newVal) {
      if (newVal) {
        this.rechargeSupportImageLoadError = false
      }
    },
  },
  created() {
    this.loadInitialData()
  },

  mounted() {
    // Usamos $nextTick para asegurarnos de que el DOM esté completamente actualizado
    // antes de intentar manipular cualquier elemento del DOM.
    this.$nextTick(() => {
      // Si la propiedad 'ready' ya es true, añadimos el listener de enfoque al botón.
      if (this.ready) {
        this.addFocusListenerToElement('mediaCode', 'textoVoz.codigoQr');
        this.addFocusListenerToElement('continue', 'textoVoz.continuar');
      }
    });
  
    // Configuramos un watcher en la propiedad 'ready' para detectar cambios en su valor.
    this.$watch('ready', (newVal) => {
      // Si 'ready' cambia a true, usamos $nextTick para esperar a que el DOM se actualice completamente.
      if (newVal) {
        this.$nextTick(() => {
          // Añadimos el listener de enfoque al botón.
          this.addFocusListenerToElement('mediaCode', 'textoVoz.codigoQr');
          this.addFocusListenerToElement('continue', 'textoVoz.continuar');
        });
      }
    });
    // Observamos la creación del elemento #owner_media_type y foreign_media_type en el DOM
    this.observeElementCreation('#owner_media_type', () => {
      this.addFocusListenerToElementDinamic('owner_media_type', 'textoVoz.recargarMiCuenta');
      if(this.administrativeArea.config.enable_qr){
        this.addFocusListenerToElementDinamic('foreign_media_type', 'textoVoz.recargarOtraCuenta');
      }
     
    });
      // Observamos la creación de los elementos con name="tscRadio" y name="qrRadio"
    this.observeElementCreation('input[name="tscRadio"]', (element) => {
      this.addFocusListenerToElementByName('tscRadio', 'textoVoz.seleccioneTarjeta');
    });

    this.observeElementCreation('input[name="qrRadio"]', (element) => {
      this.addFocusListenerToElementByName('qrRadio', 'textoVoz.seleccioneCuenta');
    });
    this.getSupportTypes()
  },
  methods: {
    ...mapActions('administrativeArea', ['loadAdministrativeArea']),

    clientMediaType(type) {
      if (type === '2' && !this.administrativeArea.enable_qr) {
        return false
      }

      return true
    },

    onRechargeSupportImageError() {
      this.rechargeSupportImageLoadError = true
    },

    mediaTypeOrSupportType(id) {
      // verifica si tiene media_type TSC monedero
      const media_type_1 = this.administrativeArea.media_types?.some(
        type => type.code.toString() === '1'
      )
      // verifica si tiene support_type TSC producto
      const support_type_1 = this.supportTypes?.some(type => type.code.toString() === '1')

      if ((id === 'qr_radio') && !this.administrativeArea.enable_qr) {
        return false
      }

      return ((support_type_1 || media_type_1) && id === 'tsc_radio') || (id === 'qr_radio')
    },

    // foreignRecharge() {
    //   // verifica si tiene media_type TSC monedero
    //   const media_type_1 = this.administrativeArea.media_types?.some(
    //     types => types.code.toString() === '1'
    //   )

    //   // verifica si tiene support_type TSC producto
    //   const support_type_1 = this.supportTypes?.some(types => types.code.toString() === '1')

    //   if (!media_type_1 && !support_type_1) {
    //     if (!this.administrativeArea?.enable_abt_account || !this.administrativeArea?.enable_qr) {
    //       return false
    //     }
    //   }

    //   return true
    // },

    async getSupportTypes() {
      if (this.administrativeArea.id !== undefined) {
        const params = {
          administrative_area_id: this.administrativeArea.id
        }

        const supportTypes = await SupportTypes.index(params)
        this.supportTypes = supportTypes
      }
    },

    // Obtiene productos asociados a una tsc y sus precios
    async productsByCard() {
      const media_code = this.currentMediaSelected.mediaCode
      const data = await ProductsPrice.productPrice({media_code})
      this.products = data

      await this.$emit('update-products', this.products)
      this.advance()
    },

    observeElementCreation(selector, callback) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const element = document.querySelector(selector);
            if (element) {
              callback();
              observer.disconnect();
              break;
            }
          }
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    async loadInitialData() {
      await this.getAdministrativeAreas()
      await this.calculateClientMedia()

      this.isNominalRecharge = this.formData.is_nominal_recharge

      if (!this.isNominalRecharge) {
        this.media_type = this.formData.media_type || '1'
        this.media_code = this.formData.media_code
      } else {
        // this.media_type = DEFAULT_MEDIA_TYPE
        this.media_code = undefined
        this.media_type = '1'
      }
    },

    addFocusListenerToElement(elementId, text ) {
      const element = document.getElementById(elementId);
      if (element) {
        // Asegurarse de que el elemento puede recibir el foco
        element.setAttribute('tabindex', '7');
  
        // Agregar un listener para el evento focus
        element.addEventListener('focus', () => {
          const textoescuchar = this.$t(text);
          this.escucharAudio(textoescuchar);
        });
  
        // Agregar un listener para el evento blur para quitar el foco
        element.addEventListener('blur', () => {
          element.classList.remove('focused');
        });
      } else {
        // devDump(`El elemento con id '${elementId}' no se encontró en el DOM.`);
      }
    },
    addFocusListenerToElementDinamic (elementId, text) {
      const element = document.getElementById(elementId);
      if (element) {
        const label = element.closest('label');
        if (label) {
          // Asegurarse de que el elemento puede recibir el foco
          element.setAttribute('tabindex', '7');
  
          // Agregar un listener para el evento focus
          element.addEventListener('focus', () => {
            label.classList.add('focused');
            const textoescuchar = this.$t(text);
            this.escucharAudio(textoescuchar);
          });
  
          // Agregar un listener para el evento blur para quitar el foco
          element.addEventListener('blur', () => {
            label.classList.remove('focused');
          });
        } else {
          // devDump(`No se encontró el label para el elemento con id '${elementId}'.`);
        }
      } else {
        // devDump(`El elemento con id '${elementId}' no se encontró en el DOM.`);
      }
    },
    
    addFocusListenerToElementByName(elementName, text) {
      const elements = document.getElementsByName(elementName);
      elements.forEach(element => {
        const label = element.nextElementSibling;
        if (label) {
          label.classList.add('focused');
          label.setAttribute('tabindex', '7');
          label.addEventListener('focus', () => {
            const textoEscuchar = this.$t(text);
            this.escucharAudio(textoEscuchar);
          });
  
          label.addEventListener('blur', () => {
            label.classList.remove('focused');
          });
        }
      });
    },
    calculateDefaultNominalMediaSelected(clientMediasOfCity) {
      if (this.formData.media_code) {
        this.nominalMediaSelected = clientMediasOfCity.find(
          media => media.mediaCode === this.formData.media_code
        )
      } else {
        this.nominalMediaSelected = clientMediasOfCity[0]
      }
    },

    calculateMediaId(media) {
      const isTsc = media.mediaType === '1'
      return isTsc ? `tsc_radio_${media.mediaCode}` : `qr_radio_${media.mediaCode}`
    },

    calculateMediaName(media) {
      return media.mediaType === '1' ? 'tscRadio' : 'qrRadio'
    },

    calculateMediaTranslate(media) {
      if (media.mediaType === '1') {
        return `${this.$t('recharge.basicData.tsc')} ${media.mediaCode}`
      } else if (this.administrativeAreaLoaded) {
        return `${this.$t('recharge.basicData.qr')} ${this.$currentAccount.rut}`
      }
      return ''
    },

    calculateMediaIcon(media) {
      return media.mediaType === '1' ? 'point-of-sale' : 'qr'
    },

    async calculateClientMedia() {
      const clientAccounts = this.$user && this.$user.client_accounts || []

      await Promise.all(clientAccounts.map(async account => {
        const administrativeAreaId = account.administrative_area_id

        const params = {
          administrative_area_id: administrativeAreaId,
          rut: account.rut
        }

        const response = await ApiClientsService.clientMediaInfo(params)

        const qrEnabled = this.administrativeArea?.enable_qr !== false
        let clientMedias = response.data
          .filter(media => qrEnabled || String(media.MediaType) !== '2')
          .map(media => ({
            mediaCode: media.CardSerialNumber,
            mediaType: media.MediaType,
            administrativeAreaId
          }))

        clientMedias = _.orderBy(clientMedias, ['mediaType'], ['asc'])

        this.clientMedias = {
          ...this.clientMedias,
          [administrativeAreaId]: clientMedias
        }

        if (this.clientMediasOfCurrentCity && this.currentRechargeIsNominal) {
          this.calculateDefaultNominalMediaSelected(this.clientMediasOfCurrentCity)
        }
      }))

      this.ready = true
    },
    async getAdministrativeAreas() {
      const params = {
        municipality_ids: this.availableMunicipalities.map(m => m.id),
        template: 'with_parameters_with_counter',
        per: 0
      }
      const response = await TicketingAdministrativeAreasService.index(params)
      this.administrativeAreas = response.data
      this.setAdministrativeArea()
    },
    setAdministrativeArea() {
      const {currentMunicipality, administrativeAreas} = this

      if (!currentMunicipality) { return }

      const actualAdministrativeArea = administrativeAreas.find(administrativeArea => (
        currentMunicipality?.administrative_area_ids?.includes(administrativeArea.id)
      ))

      if (actualAdministrativeArea) {
        this.administrative_area_id = actualAdministrativeArea.id
        this.selectorDisabled = true
      }
    },
    checkMedia() {
      this.administrativeAreaCodeError = undefined
      this.mediaCodeError = undefined

      const params = {
        administrative_area_id: this.administrative_area_id,
        administrative_area_code: this.administrative_area_code,
        media_type: this.currentMediaSelected.mediaType,
        media_code: this.currentMediaSelected.mediaCode
      }

      if (this.validateFields(params)) {
        PassengerPaymentMediasService.canRecharge({params}).then(response => {
          // Si es recarga de producto, busca productos asociados a la card
          if (Object.keys(response.data).length > 0) {
            localStorage.setItem('cardResponse', true)
            this.productsByCard()
          } else {
            localStorage.setItem('cardResponse', false)
            this.advance()
          }
        }).catch(response => {
          this.insertErrorsInMediaCodeError(response)
        })
      }
    },
    validateFields(params) {
      let bool = true

      if (!params.administrative_area_code) {
        this.administrativeAreaCodeError = this.$t('recharge.basicData.administrativeAreaCodeError')
        bool = false
      }

      if (!this.currentRechargeIsNominal) {
        if (!params.media_code) {
          this.mediaCodeError = this.$t('recharge.basicData.mediaCodeError')
          bool = false
        }
      }

      return bool
    },
    async advance() {

      if (!this.administrativeAreaLoaded) {
        await this.loadAdministrativeArea({administrativeAreaId: this.administrative_area_id})
      }

      this.$emit('advance', {
        administrative_area_id: this.administrative_area_id,
        administrative_area_code: this.administrative_area_code,
        media_type: this.currentMediaSelected.mediaType,
        media_code: this.currentMediaSelected.mediaCode,
        is_nominal_recharge: this.currentRechargeIsNominal
      })
    },
    scrollToBottom() {
      setTimeout(() => {
        window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})
      }, 100)
    },

    insertErrorsInMediaCodeError(errors) {
      let stringError = ''
      Object.entries(errors).forEach(([key, value]) => {
        stringError = stringError.concat(this.$t(`recharge.basicData.${key}.${value}`))
      })

      this.mediaCodeError = stringError
    },

    validarQR(data) {
      return true
    }
  }
})
